import React, { useEffect } from 'react'
import { AnimatePresence, delay, motion } from 'framer-motion';
import useStore from './store';
import Navbar from './Navbar';
import About1 from './About1';
import Forte from './Forte';
import $ from "jquery"
import Into from './Into';
const Home = () => {

  useEffect(() => {
    function scrollFunction() {
const htmlElement = document.querySelector(".heroElem")      
      $(".invisible1").css("opacity", 1 - 0.5*$(window).scrollTop() / htmlElement.clientHeight );
      $(".invisible1").css("scale",  1 - 0.1*$(window).scrollTop() / htmlElement.clientHeight );
    }
    window.addEventListener("scroll", scrollFunction)

  },[]  )

  const { count1 } = useStore();

 
  


  return (


<div >


    <div className='relative min-h-[100svh] flex justify-center items-center pt-[25vh] pb-10 overflow-hidden  text-black dark:text-white font-extrabold border-white top-0 left-0 right-0 h-screen -z-1 md:pb-32 bg-background    ' id="home"  >
      <div className='cir opacity-60  fixed   top-[10%] left-[10%] bg-purple-700 h-96 w-[30%] rounded-xl mix-blend-multiply filter blur-3xl md:opacity-30 ' />
      <div className='cir opacity-60 fixed   top-[30%] right-[10%] bg-green-500 h-[20%] w-[40%] -z-30 rounded-full mix-blend-multiply filter blur-3xl md:opacity-30  ' />


      <div className=' z-10 flex flex-col items-center  league-spartan-medium  justify-center gap-3     ' >
        <div className=' fixed flex flex-col self-center place-self-center justify-center  items-center    heroElem   text-black    max-w-5xl invisible1    '  >

          <p className=' w-fit tracking-wider text-sm md:text-2xl font-semibold   '> HEY, I'M HEMIL DUDHAT</p>
          <p className='heroTitle text-center inline-block max-w-2xl lg:max-w-4xl  w-auto relative text-5xl md:text-6xl lg:text-7xl tracking-tighter mb-5 font-bold  lato-bold  p-3 pt-0   flex-wrap  leading-tight '>Ready to turn your digital idea into reality?</p>
        <button className='pop group ring-1 ring-black rounded-full p-3  pl-6 pr-6 ring-offset-black flex gap-4 align-middle justify-around text-md ' > Let's do it


          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="group-hover:rotate-90 transition-transform duration-300"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
        </button>
        </div>
      </div>

      </div>
      
        <div className=' '> 
        <About1 />
        <Forte />
        </div>

        </div>
  )
}

export default Home